// extracted by mini-css-extract-plugin
export var inner = "index-module--inner--80c4a";
export var outer = "index-module--outer--5198e";